import { makeStyles, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: tokens.spacingVerticalL,
    paddingBottom: tokens.spacingVerticalM,
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    flex: 1,
    minWidth: 0,
  },
  link: {
    height: tokens.spacingHorizontalXXXL,
    width: tokens.spacingHorizontalXXXL,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  backIcon: {
    height: tokens.spacingHorizontalXL,
    width: tokens.spacingHorizontalXL,
    color: tokens.colorNeutralForeground1,
  },
  heading: {
    margin: 0,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '2px',
    flexShrink: 0,
  },
})

export { useStyles }
